module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "campaign-summary",
    on: {
      "touchmove": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
      }
    }
  }, [(_vm.info) ? _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(_vm.buttonState == 0) ? _c('el-button', {
    attrs: {
      "size": "mini",
      "type": "primary",
      "round": ""
    },
    on: {
      "click": _vm.copy
    }
  }, [_vm._v(_vm._s(_vm.buttonText[_vm.buttonState]))]) : _c('el-button', {
    attrs: {
      "size": "mini",
      "type": "success",
      "round": ""
    },
    on: {
      "click": _vm.copy
    }
  }, [_vm._v("\n            " + _vm._s(_vm.buttonText[_vm.buttonState]) + "\n        ")])], 1) : _vm._e(), _vm._v(" "), _c('textarea', {
    ref: "copyText",
    staticClass: "hidden",
    attrs: {
      "type": "text",
      "contenteditable": "true"
    }
  }, [_vm._v(_vm._s(_vm.copyText))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (!_vm.info),
      expression: "!info"
    }],
    staticClass: "summary"
  }, [_c('transition-group', {
    attrs: {
      "name": "fade"
    }
  }, _vm._l((_vm.info), function(step, key) {
    return _c('el-card', {
      key: key,
      staticClass: "box-card"
    }, [_c('h1', [_vm._v(_vm._s(_vm.stepTitles[key]))]), _vm._v(" "), _vm._l((step), function(val, field) {
      return (_vm.summaryTitles[field] && val && val.length > 0) ? _c('div', {
        key: field,
        staticClass: "attribute"
      }, [_c('span', {
        staticClass: "field"
      }, [_vm._v(_vm._s(_vm.summaryTitles[field]) + ": ")]), _vm._v(" "), (!val || val.indexOf('http') !== 0) ? _c('span', {
        staticClass: "value"
      }, [_vm._v(_vm._s(val))]) : _c('span', {
        staticClass: "value"
      }, [_c('a', {
        attrs: {
          "href": val,
          "target": "_blank"
        }
      }, [_vm._v(_vm._s(val))])])]) : _vm._e()
    })], 2)
  }))], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-703e10a8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/campaign-summary.vue
// module id = vh7h
// module chunks = 1